import React, { HTMLAttributes } from 'react';
import { PagingInputGq } from '../../../graphql/users/models/PagingInputGq';
import { PagingResultGq } from '../../../graphql/users/models/PagingResultGq';
import VoxelTablePagination from './VoxelTablePagination';

export interface VoxelTablePaginationDataSpecificProps
  extends Pick<HTMLAttributes<HTMLTableRowElement>, 'onClick'> {
  colSpan: number;
  className?: string;
  pagingInput: PagingInputGq;
  pagingResult?: PagingResultGq;
  onPagingChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    paging: PagingInputGq
  ) => void;
}

export const VoxelTablePaginationDataSpecific: React.FC<VoxelTablePaginationDataSpecificProps> = ({
  children,
  colSpan,
  onClick,
  className,
  pagingInput,
  pagingResult,
  onPagingChange,
  ...divProps
}) => {
  return (
    <VoxelTablePagination
      children={children}
      currentPage={pagingResult?.page ?? pagingInput.page ?? 0}
      rowsPerPage={pagingResult?.amountPerPage ?? pagingInput.amountPerPage ?? 10}
      totalCount={pagingResult?.count ?? 0}
      onPageChange={(event, page) => onPagingChange(event, { ...pagingInput, page: page })}
      colSpan={colSpan}
      {...divProps}
    />
  );
};

export default VoxelTablePaginationDataSpecific;
